import { defineComponent as _defineComponent } from 'vue'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const __default__ = require('@nuxtjs/composition-api').defineComponent({
  name: 'PodcastsIndex',
  layout: 'default',
  head: {},
  jsonld() {
    // @ts-ignore
    return this.$jsonSchemaPage(this.title, this.$route.path);
  },
});

import { useMeta, useRoute, onMounted, useContext } from '@nuxtjs/composition-api';
import ResourcesList from '~/components/resource/ResourcesList.vue';
import PodcastLinks from '~/components/resource/PodcastLinks.vue';

export interface PlatformLinkInterface {
  name: string;
  link: string;
  image: string;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose }) {

/* Teach Starter Podcasts
 *
 * @parent:
 * @requests:
 * @events:
 * @props:
 * @components: ResourcesList, PodcastLinks
 * @methods:
 */

const { $hrefLangsPage, i18n, $mzAnalyticsApi } = useContext();

const $route = useRoute();

const title = 'Teach Starter Podcast';
const description =
  "Join us as we chat to inspirational, everyday teachers. It's real, it's uplifting, it's funny: it's for the love of teaching!";
const params = {
  category: 'for-the-love-of-teaching-podcast',
  country: i18n.locale,
  payload: 'basic',
  page: $route.value.query.page ? parseInt($route.value.query.page as string) : 1,
  perPage: 30,
  orderBy: 'created',
  types: ['podcast'],
};
const platformLinks: PlatformLinkInterface[] = [
  {
    name: 'Apple Podcasts',
    link: 'https://itunes.apple.com/us/podcast/for-the-love-of-teaching/id1450756371?mt=2&amp;uo=4',
    image: 'icon-podcast-apple.png',
  },
  {
    name: 'Google Podcasts',
    link: 'https://podcasts.google.com/feed/aHR0cHM6Ly93d3cub21ueWNvbnRlbnQuY29tL2QvcGxheWxpc3QvMmZiMzc0MGQtMzQzNi00NGFmLThjYzAtYTkxOTAwNzE2YWE1LzM3ZWQxZjRiLTI0NzktNGM0YS1iZGNjLWFjMGQwMTgyOWM2ZC9mODdmNTM2Ny0wZDA2LTQ5NjUtODEwYS1hYzBkMDE4MjljNmQvcG9kY2FzdC5yc3M',
    image: 'icon-podcast-google.png',
  },
  {
    name: 'Spotify',
    link: 'https://open.spotify.com/show/6tyLl5b4uQJA8oKX1rO32W',
    image: 'icon-podcast-spotify.png',
  },
  { name: 'Pocket Casts', link: 'https://pca.st/4i09', image: 'icon-podcast-pocket.png' },
  {
    name: 'Breaker',
    link: 'https://www.breaker.audio/for-the-love-of-teaching',
    image: 'icon-podcast-breaker.png',
  },
  {
    name: 'Stitcher',
    link: 'https://www.stitcher.com/podcast/anchor-podcasts/for-the-love-of-teaching',
    image: 'icon-podcast-stitcher.png',
  },
];

useMeta({
  title,
  meta: [
    { hid: 'title', name: 'title', content: title },
    { hid: 'description', name: 'description', content: description },
  ],
  link: $hrefLangsPage($route.value),
});
onMounted(() => {
  $mzAnalyticsApi({
    event: 'pageView',
  });
});

expose({
  title,
});

return { __sfc: true,$hrefLangsPage, i18n, $mzAnalyticsApi, $route, title, description, params, platformLinks, ResourcesList, PodcastLinks }
}

})